function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React, { useState } from 'react';
// import { TableCell, Text } from "grommet";
import { classes, useDeepCompareMemo } from '../utils';
export const Cell = /*#__PURE__*/React.memo(({
  cell,
  TdComponent,
  ...rest
}) => {
  const [cellProps, setCellProps] = useState({});
  const {
    value,
    row,
    column
  } = cell;
  let deps = [value, column.isResizing, column.isVisible, column.sortDescFirst, row.index, row?.original, ...(column.id === 'selection' ? [row.isSelected] : []), ...(column.id === 'utils' || column.isExpandableColumn ? [row.isExpanded] : [])
  // ...([cell.render] ?? []),
  ];

  const renderCell = useDeepCompareMemo(() => {
    return cell.render('Cell');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  // useDeepCompareEffect(() => {
  //   if (column.collapsed) setCellProps(cell.getCellProps());
  // }, [cell.getCellProps]);

  return /*#__PURE__*/React.createElement(TdComponent, _extends({
    className: classes(`${typeof column.hoverVisible === 'function' ? column.hoverVisible(row) ? 'rt-hover-visible' : '' : column.hoverVisible ? 'rt-hover-visible' : ''}`, column.align === 'right' && 'rt-right-align')
  }, rest, cellProps), renderCell);
});
Cell.displayName = 'Cell';